export const mivasaGroup = {
  siteName: "mivasa",
  senderName: "Mivasa Group",
  logo: "/static/warbox_logo.png",
  name: "Mivasa Group",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "mivasa-group",
};
